
import { defineComponent, onBeforeMount, ref } from 'vue';
// import router from '@/router';
import Generic from '@/components/global/GenericModal.vue';
import axios, { AxiosError } from 'axios';
import ErrorMessage from '@/components/global/ErrorMessage.vue';
import Greetings from '@/components/global/Greetings.vue';
import { fetchLearnerStatusForReview, requestForRereview } from '../utils/re_review_service';

export default defineComponent({
  name: 'LearnerRereview',
  components: { Generic, ErrorMessage, Greetings },
  // props: ['query'],
  props: {
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const learnerTaskId = ref(props.query.learner_task_id);
    const learnerRereviewDetails = ref();
    const modalVisible = ref(false);
    const modalMessage = ref();
    const buttonDisable = ref(true);
    const renderReady = ref(false);
    const errorResponse = ref();
    const showErrorMessage = ref(false);
    const helpmateLink = ref(localStorage.getItem('helpmateLink'));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const setRereviewButtonEnable = (e: any) => {
      const cb = e.target.checked;
      if (cb === true) {
        buttonDisable.value = false;
        console.log(buttonDisable.value);
      } else {
        buttonDisable.value = true;
        console.log(buttonDisable.value);
      }
    };

    const requestForRereviewSubmit = async () => {
      try {
        renderReady.value = false;
        if (learnerRereviewDetails.value.is_plagiarised && learnerRereviewDetails.value.plagiarism_reevaluation_requested) {
          modalVisible.value = true;
          modalMessage.value = 'Learner already requested for re-evaluation for plagiarism so cannot request for re-review now';
          return;
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const res: any = await requestForRereview(learnerTaskId.value, false);
        learnerRereviewDetails.value.request_for_re_review = res.data?.request_for_re_review;
        learnerRereviewDetails.value.re_review_status = res.data?.re_review_status;
        renderReady.value = true;
        modalVisible.value = true;
        modalMessage.value = '<strong>Re-review in Progress</strong>,<br> You’ll receive an email as soon as the review is complete.';
      } catch (error) {
        // modalVisible.value = true;
        // modalMessage.value = `There is an issue in requesting for review ${error}`;
        console.log('inside catch error');
        console.log(JSON.stringify(error));
        renderReady.value = true;
        // localStorage.setItem('errorMsg', JSON.stringify(error));
        // router.push({ path: '/solidify/Error' });
        if (axios.isAxiosError(error)) {
          const err = error as AxiosError;
          console.log(err.response?.data);
          errorResponse.value = err.response?.data;
          // console.log(`errorMessage.value ${errorMessage.value}`);
        } else {
          errorResponse.value = 'There is an issue in requesting for review, please contact helpmate.';
        }
        showErrorMessage.value = true;
        // console.log(error);
      }
    };
    const checkRereviewStatus = async () => {
      try {
        renderReady.value = false;
        const res = await fetchLearnerStatusForReview(learnerTaskId.value);
        learnerRereviewDetails.value = res.data;
        renderReady.value = true;
        console.log(`after check status ${JSON.stringify(learnerRereviewDetails)}`);
        if (learnerRereviewDetails.value.re_review_status === 'Re-review Accepted Proxy Assigned' || learnerRereviewDetails.value.re_review_status === 'Re-review Accepted Proxy Unavailable') {
          modalVisible.value = true;
          modalMessage.value = '<br><strong>Re-review in Progress</strong>,<br> You’ll receive an email as soon as the review is complete.';
        } else if (learnerRereviewDetails.value.re_review_status === 'Complete') {
          modalVisible.value = true;
          modalMessage.value = '<br><br>Great news! Your re-review is complete — check your email for details.';
        }
        return;
      } catch (error) {
        // modalVisible.value = true;
        // modalMessage.value = `There is an issue in fetching learner re-review status ${error}`;
        console.log('inside catch error');
        console.log(JSON.stringify(error));
        renderReady.value = true;
        // localStorage.setItem('errorMsg', JSON.stringify(error));
        // router.push({ path: '/solidify/Error' });
        if (axios.isAxiosError(error)) {
          const err = error as AxiosError;
          console.log(err.response?.data);
          errorResponse.value = err.response?.data;
          // console.log(`errorMessage.value ${errorMessage.value}`);
        } else {
          errorResponse.value = 'There is an issue in fetching learner re-review status, please contact helpmate.';
        }
        showErrorMessage.value = true;
      }
    };

    onBeforeMount(async () => {
      try {
        renderReady.value = false;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const res: any = await fetchLearnerStatusForReview(learnerTaskId.value);
        learnerRereviewDetails.value = res.data;
        renderReady.value = true;
        console.log(`learnerRereviewDetails.value ${JSON.stringify(learnerRereviewDetails.value)}`);
        if (learnerRereviewDetails.value.is_plagiarised && learnerRereviewDetails.value.plagiarism_reevaluation_requested) {
          modalVisible.value = true;
          modalMessage.value = 'Learner already requested for re-evaluation for plagiarism so cannot request for re-review now';
        }
      } catch (error) {
        // modalVisible.value = true;
        // modalMessage.value = 'There is an issue to fetch existing record';
        console.log('inside catch error');
        console.log(JSON.stringify(error));
        renderReady.value = true;
        // localStorage.setItem('errorMsg', JSON.stringify(error));
        // router.push({ path: '/solidify/Error' });
        if (axios.isAxiosError(error)) {
          const err = error as AxiosError;
          console.log(err.response?.data);
          errorResponse.value = err.response?.data;
          // console.log(`errorMessage.value ${errorMessage.value}`);
        } else {
          errorResponse.value = 'There is an issue to fetch existing record, please contact helpmate.';
        }
        showErrorMessage.value = true;
      }
    });
    return {
      modalVisible,
      modalMessage,
      buttonDisable,
      learnerRereviewDetails,
      setRereviewButtonEnable,
      requestForRereviewSubmit,
      checkRereviewStatus,
      renderReady,
      helpmateLink,
      showErrorMessage,
    };
  },
});
